
import React from 'react';
import { cn } from "@/lib/utils";
import BusinessCard from '@/components/BusinessCard';
import { Business } from '@/schemas/business'; // Changed import path
import { BusinessStatus } from '@/types/schema/commonSchema';

interface PortfolioSectionContentProps {
  isExpanded: boolean;
  businesses: Business[];
  isGridView: boolean;
  emptyState?: React.ReactNode;
}

const PortfolioSectionContent: React.FC<PortfolioSectionContentProps> = ({
  isExpanded,
  businesses,
  isGridView,
  emptyState
}) => {
  if (!isExpanded) {
    return null;
  }
  
  const renderBusinessCards = () => (
    <div className={cn(
      isGridView ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" : "space-y-1"
    )}>
      {businesses.map((business) => {
        // Map any legacy status to one of our current allowed values
        let mappedStatus: BusinessStatus = business.status as BusinessStatus || 'onboarding';
        
        // Handle any potential legacy statuses as strings
        const statusStr = business.status as string;
        if (statusStr && !['active', 'paused', 'onboarding'].includes(statusStr)) {
          // Map legacy statuses to current ones
          if (statusStr === 'inactive' || statusStr === 'deactivated') {
            mappedStatus = 'paused';
          }
        }
        
        // Ensure we always have a title to display by using name OR title OR a default
        const businessTitle = business.name || business.title || "Unnamed Business";
        
        return (
          <BusinessCard
            key={business.id}
            id={business.id}
            title={businessTitle}
            address={business.address || ''}
            status={mappedStatus}
            role={business.role}
            showActions={business.showActions}
            isGridView={isGridView}
            industry={business.industry || ''}
            package={business.package}
            logoUrl={business.logoUrl}
          />
        );
      })}
    </div>
  );

  const renderEmptyState = () => (
    emptyState || (
      <div className="text-center py-2 text-gray-500">
        No businesses in this portfolio.
      </div>
    )
  );
  
  return (
    <div className="space-y-1 animate-slide-up mt-1 mb-4">
      {businesses.length > 0 ? renderBusinessCards() : renderEmptyState()}
    </div>
  );
};

export default PortfolioSectionContent;
